"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _abarth = _interopRequireDefault(require("../img/car-brands/abarth.png"));
var _alfaRomeo = _interopRequireDefault(require("../img/car-brands/alfa-romeo.png"));
var _astonMartin = _interopRequireDefault(require("../img/car-brands/aston-martin.png"));
var _audi = _interopRequireDefault(require("../img/car-brands/audi.png"));
var _bentley = _interopRequireDefault(require("../img/car-brands/bentley.png"));
var _BMW = _interopRequireDefault(require("../img/car-brands/BMW.png"));
var _buick = _interopRequireDefault(require("../img/car-brands/buick.png"));
var _cadillac = _interopRequireDefault(require("../img/car-brands/cadillac.png"));
var _chevrolet = _interopRequireDefault(require("../img/car-brands/chevrolet.png"));
var _chrysler = _interopRequireDefault(require("../img/car-brands/chrysler.png"));
var _citroen = _interopRequireDefault(require("../img/car-brands/citroen.png"));
var _cupra = _interopRequireDefault(require("../img/car-brands/cupra.png"));
var _dacia = _interopRequireDefault(require("../img/car-brands/dacia.png"));
var _daewoo = _interopRequireDefault(require("../img/car-brands/daewoo.png"));
var _daihatsu = _interopRequireDefault(require("../img/car-brands/daihatsu.png"));
var _dodge = _interopRequireDefault(require("../img/car-brands/dodge.png"));
var _DS = _interopRequireDefault(require("../img/car-brands/DS.png"));
var _ferrari = _interopRequireDefault(require("../img/car-brands/ferrari.png"));
var _fiat = _interopRequireDefault(require("../img/car-brands/fiat.png"));
var _ford = _interopRequireDefault(require("../img/car-brands/ford.png"));
var _goupil = _interopRequireDefault(require("../img/car-brands/goupil.png"));
var _greatWall = _interopRequireDefault(require("../img/car-brands/great-wall.png"));
var _honda = _interopRequireDefault(require("../img/car-brands/honda.png"));
var _hyundai = _interopRequireDefault(require("../img/car-brands/hyundai.png"));
var _infiniti = _interopRequireDefault(require("../img/car-brands/infiniti.png"));
var _jaguar = _interopRequireDefault(require("../img/car-brands/jaguar.png"));
var _jeep = _interopRequireDefault(require("../img/car-brands/jeep.png"));
var _kiaMotors = _interopRequireDefault(require("../img/car-brands/kia-motors.png"));
var _lancia = _interopRequireDefault(require("../img/car-brands/lancia.png"));
var _landRover = _interopRequireDefault(require("../img/car-brands/land-rover.png"));
var _lexus = _interopRequireDefault(require("../img/car-brands/lexus.png"));
var _lichi = _interopRequireDefault(require("../img/car-brands/lichi.png"));
var _lincoln = _interopRequireDefault(require("../img/car-brands/lincoln.png"));
var _maserati = _interopRequireDefault(require("../img/car-brands/maserati.png"));
var _mazda = _interopRequireDefault(require("../img/car-brands/mazda.png"));
var _mercedesBenz = _interopRequireDefault(require("../img/car-brands/mercedes-benz.png"));
var _mg = _interopRequireDefault(require("../img/car-brands/mg.png"));
var _mitsubushi = _interopRequireDefault(require("../img/car-brands/mitsubushi.png"));
var _nanjing = _interopRequireDefault(require("../img/car-brands/nanjing.png"));
var _nissan = _interopRequireDefault(require("../img/car-brands/nissan.png"));
var _opel = _interopRequireDefault(require("../img/car-brands/opel.png"));
var _peugeot = _interopRequireDefault(require("../img/car-brands/peugeot.png"));
var _porche = _interopRequireDefault(require("../img/car-brands/porche.png"));
var _renault = _interopRequireDefault(require("../img/car-brands/renault.png"));
var _rover = _interopRequireDefault(require("../img/car-brands/rover.png"));
var _saab = _interopRequireDefault(require("../img/car-brands/saab.png"));
var _seat = _interopRequireDefault(require("../img/car-brands/seat.png"));
var _skoda = _interopRequireDefault(require("../img/car-brands/skoda.png"));
var _smart = _interopRequireDefault(require("../img/car-brands/smart.png"));
var _ssangyong = _interopRequireDefault(require("../img/car-brands/ssangyong.png"));
var _subaru = _interopRequireDefault(require("../img/car-brands/subaru.png"));
var _suzuki = _interopRequireDefault(require("../img/car-brands/suzuki.png"));
var _tazzari = _interopRequireDefault(require("../img/car-brands/tazzari.png"));
var _toyota = _interopRequireDefault(require("../img/car-brands/toyota.png"));
var _volkswagen = _interopRequireDefault(require("../img/car-brands/volkswagen.png"));
var _volvo = _interopRequireDefault(require("../img/car-brands/volvo.png"));
var _tesla = _interopRequireDefault(require("../img/car-brands/tesla.png"));
var _byd = _interopRequireDefault(require("../img/car-brands/byd.png"));
var _skywell = _interopRequireDefault(require("../img/car-brands/skywell.png"));
var _geely = _interopRequireDefault(require("../img/car-brands/geely.png"));
var _seres = _interopRequireDefault(require("../img/car-brands/seres.png"));
var _aiways = _interopRequireDefault(require("../img/car-brands/aiways.png"));
var _maxus = _interopRequireDefault(require("../img/car-brands/maxus.png"));
var _gac = _interopRequireDefault(require("../img/car-brands/gac.png"));
var _leap = _interopRequireDefault(require("../img/car-brands/leap.png"));
var _genesis = _interopRequireDefault(require("../img/car-brands/genesis.png"));
var _hongqi = _interopRequireDefault(require("../img/car-brands/hongqi.png"));
var _levc = _interopRequireDefault(require("../img/car-brands/levc.png"));
var _lvtong = _interopRequireDefault(require("../img/car-brands/lvtong.png"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
// car-brands logos

var carBrandsData = [{
  imgSrc: _abarth.default,
  label: 'אבארט',
  value: 738
}, {
  imgSrc: _aiways.default,
  label: 'איוויס',
  value: 531
}, {
  imgSrc: _audi.default,
  label: 'אודי',
  value: 19
}, {
  imgSrc: _opel.default,
  label: 'אופל',
  value: 33
}, {
  imgSrc: _infiniti.default,
  label: 'אינפיניטי',
  value: 625
}, {
  imgSrc: _alfaRomeo.default,
  label: 'אלפא רומאו',
  value: 74
}, {
  imgSrc: _mg.default,
  label: 'אם ג\'י',
  value: 818
}, {
  imgSrc: _astonMartin.default,
  label: 'אסטון מרטין',
  value: 349
}, {
  imgSrc: _BMW.default,
  label: 'ב.מ.וו.',
  value: 143
}, {
  imgSrc: _buick.default,
  label: 'ביואיק',
  value: 156
}, {
  imgSrc: _bentley.default,
  label: 'בנטלי',
  value: 983
}, {
  imgSrc: _byd.default,
  label: 'בי.וואי.די',
  value: 235
}, {
  imgSrc: _jeep.default,
  label: 'ג\'יפ',
  value: 870
}, {
  imgSrc: _gac.default,
  label: 'ג\'יי.איי.סי',
  value: 420
}, {
  imgSrc: _goupil.default,
  label: 'גופיל',
  value: 416
}, {
  imgSrc: _greatWall.default,
  label: 'גרייט וול',
  value: 944
}, {
  imgSrc: _dacia.default,
  label: 'דאצ\'יה',
  value: 351
}, {
  imgSrc: _dodge.default,
  label: 'דודג\'',
  value: 259
}, {
  imgSrc: _DS.default,
  label: 'די אס DS',
  value: 819
}, {
  imgSrc: _daewoo.default,
  label: 'דייהו',
  value: 288
}, {
  imgSrc: _daihatsu.default,
  label: 'דייהטסו',
  value: 281
}, {
  imgSrc: _genesis.default,
  label: 'ג\'נסיס',
  value: 272
}, {
  imgSrc: _geely.default,
  label: 'ג\'ילי',
  value: 964
}, {
  imgSrc: _honda.default,
  label: 'הונדה',
  value: 312
}, {
  imgSrc: _volvo.default,
  label: 'וולוו',
  value: 361
}, {
  imgSrc: _toyota.default,
  label: 'טויוטה',
  value: 413
}, {
  imgSrc: _tazzari.default,
  label: 'טזארי',
  value: 417
}, {
  imgSrc: _tesla.default,
  label: 'טסלה',
  value: 299
}, {
  imgSrc: _jaguar.default,
  label: 'יגואר',
  value: 465
}, {
  imgSrc: _hyundai.default,
  label: 'יונדאי',
  value: 481
}, {
  imgSrc: _hongqi.default,
  label: 'הונגצ\'י',
  value: 314
}, {
  imgSrc: _lincoln.default,
  label: 'לינקולן',
  value: 509
}, {
  imgSrc: _lichi.default,
  label: 'ליצ\'י',
  value: 418
}, {
  imgSrc: _landRover.default,
  label: 'לנד רובר',
  value: 510
}, {
  imgSrc: _lancia.default,
  label: 'לנצ\'יה',
  value: 513
}, {
  imgSrc: _leap.default,
  label: 'ליפ',
  value: 368
}, {
  imgSrc: _lexus.default,
  label: 'לקסוס',
  value: 414
}, {
  imgSrc: _levc.default,
  label: 'אלאיויסי',
  value: 1425
}, {
  imgSrc: _lvtong.default,
  label: 'אל.וי.טונג',
  value: 415
}, {
  imgSrc: _mazda.default,
  label: 'מאזדה',
  value: 588
}, {
  imgSrc: _maserati.default,
  label: 'מזראטי',
  value: 555
}, {
  imgSrc: _maxus.default,
  label: 'מקסוס',
  value: 443
}, {
  imgSrc: _mitsubushi.default,
  label: 'מיצובישי',
  value: 590
}, {
  imgSrc: _mercedesBenz.default,
  label: 'מרצדס',
  value: 274
}, {
  imgSrc: _nanjing.default,
  label: 'נאנג\'ין',
  value: 419
}, {
  imgSrc: _nissan.default,
  label: 'ניסאן',
  value: 624
}, {
  imgSrc: _saab.default,
  label: 'סאאב',
  value: 644
}, {
  imgSrc: _ssangyong.default,
  label: 'סאנגיונג',
  value: 712
}, {
  imgSrc: _subaru.default,
  label: 'סובארו',
  value: 650
}, {
  imgSrc: _suzuki.default,
  label: 'סוזוקי',
  value: 683
}, {
  imgSrc: _seat.default,
  label: 'סיאט',
  value: 778
}, {
  imgSrc: _citroen.default,
  label: 'סיטרואן',
  value: 817
}, {
  imgSrc: _seres.default,
  label: 'סרס',
  value: 886
}, {
  imgSrc: _smart.default,
  label: 'סמארט',
  value: 273
}, {
  imgSrc: _skoda.default,
  label: 'סקודה',
  value: 676
}, {
  imgSrc: _skywell.default,
  label: 'סקייוול',
  value: 963
}, {
  imgSrc: _volkswagen.default,
  label: 'פולקסווגן',
  value: 724
}, {
  imgSrc: _ford.default,
  label: 'פורד',
  value: 729
}, {
  imgSrc: _ford.default,
  label: 'פורד אמריקאי',
  value: 728
}, {
  imgSrc: _porche.default,
  label: 'פורשה',
  value: 735
}, {
  imgSrc: _fiat.default,
  label: 'פיאט',
  value: 737
}, {
  imgSrc: _peugeot.default,
  label: 'פיג\'ו',
  value: 739
}, {
  imgSrc: _ferrari.default,
  label: 'פרארי',
  value: 770
}, {
  imgSrc: _cadillac.default,
  label: 'קאדילק',
  value: 840
}, {
  imgSrc: _cupra.default,
  label: 'קופרה',
  value: 775
}, {
  imgSrc: _kiaMotors.default,
  label: 'קיה מוטורס',
  value: 885
}, {
  imgSrc: _chrysler.default,
  label: 'קרייזלר',
  value: 869
}, {
  imgSrc: _rover.default,
  label: 'רובר',
  value: 941
}, {
  imgSrc: _renault.default,
  label: 'רנו',
  value: 928
}, {
  imgSrc: _chevrolet.default,
  label: 'שברולט',
  value: 961
}, {
  label: 'BAW',
  value: 120
}, {
  label: 'ג\'י.איי.סי',
  value: 213
}, {
  label: 'בי.ווי.די',
  value: 235
}, {
  label: 'אורה',
  value: 271
}, {
  label: 'לינק אנד קו',
  value: 325
}, {
  label: 'פולסטר',
  value: 362
}, {
  label: 'קארמה',
  value: 364
}, {
  label: 'ליפמוטור',
  value: 368
}, {
  label: 'זיקר',
  value: 411
}, {
  label: 'תודיי סאנשין',
  value: 422
}, {
  label: 'סנטרו',
  value: 424
}, {
  label: 'ניאו',
  value: 586
}, {
  label: 'וויי',
  value: 736
}, {
  label: 'וויה',
  value: 882
}, {
  label: 'אקספנג',
  value: 926
}, {
  label: 'אי.וי.איסי',
  value: 927
}, {
  label: 'צ\'רי',
  value: 929
}, {
  label: 'אלפין',
  value: 930
}, {
  label: 'איסוזו',
  value: 3127
}, {
  label: 'ג\'י.אם.סי.',
  value: 3201
}, {
  label: 'קרייזלר(ראם)',
  value: 3259
}, {
  label: 'איסוזו',
  value: 4127
}, {
  label: 'בי.ויי.די',
  value: 4235
}, {
  label: 'פוטון',
  value: 4733
}, {
  label: 'אל.אי.וי.סי',
  value: 2425
}, {
  label: 'פורד-מו',
  value: 2728
}, {
  label: 'אם.ג\'י',
  value: 2818
}, {
  label: 'אי.וי.איסי',
  value: 2927
}];
var _default = exports.default = carBrandsData;